import React from "react";

function EquipmentSelect(props) {
    const { name, label, onChange, value, options, allEquipments } = props;
    return (
        <div class="input-wrapper">
            <label htmlFor={name}>{label}</label>
            <select name={name} id={name} onChange={onChange}>
                <option value={null} selected={value == null}>
                    No Equipment
                </option>
                {options?.split(",")?.map((key) => (
                    <option value={key} selected={value == key}>
                        {allEquipments[key]}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default EquipmentSelect;
